import {Component, OnInit} from '@angular/core';
import {Router, RouterOutlet} from "@angular/router";
import {HttpClientModule} from "@angular/common/http";
import {TranslateModule} from "@ngx-translate/core";
import {ProfileService} from "@cybfed/core/services/profile-service";
import {HttpService} from "@cybfed/core/services/http.service";
import {PopupHelperService} from "@cybfed/core/services/popup-helper.service";
import {WhiteLabelService} from "@cybfed/core/services/web-site/white-label-service";
import {StorageService} from "@cybfed/core/services/storage.service";
import {EventManagerService} from "@cybfed/core/services/event-manager.service";
import {DomainService} from "@cybfed/core/utils/domain-service";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {AdminMenuService} from "@white-label/components/admin-sidebar/menu.service";
import {
    DefaultHeaderComponent
} from "@white-label/components/page-builder/components/headers/default/default-header.component";
import {
    DefaultFooterComponent
} from "@white-label/components/page-builder/components/footers/dedault/default-footer.component";
import {FeedBackComponent} from "@cybfed/shared/components/feed-back/feed-back.component";
import {ThemeService} from "@white-label/components/page-builder/theme-settings-form/themes/theme.service";
import {MeService} from "@cybfed/core/services/me.service";
import {UserStore} from "@cybfed/core/store/user.store";

@Component({
    selector: 'app-streamers',
    standalone: true,
    imports: [
        HttpClientModule,
        TranslateModule,
        RouterOutlet,
        DefaultHeaderComponent,
        DefaultFooterComponent,
        FeedBackComponent,
    ],
    providers: [
        ProfileService,
        HttpService,
        PopupHelperService,
        WhiteLabelService,
        DomainService,
        AdminMenuService,

    ],
    templateUrl: './user.component.html'
})
export class UserComponent implements OnInit {
    domainName: any;
    account: any;
    isAuth = !!StorageService.getJsonItem(StorageService.statics.currentUser)
    friendRequestStatuses = {
        PENDING: 'pending',
        ACCEPTED: 'accepted',
        DECLINED: 'declined',
        DELETED: 'deleted',
        BLOCKED: 'blocked'
    }
    friendStatuses = {
        ACTIVE: 'active',
        DELETED: 'deleted',
    }
    friendRequestStatus: any;
    actions: boolean = true;
    whiteLabelId: any
    whiteLabel: any


    constructor(
        private eventManager: EventManagerService,
        private mainStoreService: MainStoreService,
        private themeService: ThemeService,
    ) {
        this.whiteLabel = this.mainStoreService.whiteLabel
    }

    ngOnInit(): void {
        if(this.mainStoreService?.whiteLabel?.styling){
            this.themeService.applyTheme(this.mainStoreService?.whiteLabel?.styling);
        }

    }


    changeFriendReqStatus(status: string) {
        this.friendRequestStatus = status
    }

    openSendMoney() {
        this.eventManager.triggerSendTicketsModal.emit(this.account);
    }





}
